/**
 *
 */
export enum AvailabilityPeriodEnum {
  Indefinite = 1,
  Temporary = 2,
}
